import styles from './BigTitle.module.css'

const BigTitle = ({ title, className }: { title: string; className?: string }) => {
    return <div className={`${styles.BigTitle} ${className ? `` : className}`}>{title}</div>
}

export default BigTitle
